import get from "lodash/get";

const styles = (props) => {
  const {
    color,
    fontSize,
    margin,
    padding,
    borderRadius,
    fontWeight,
    typography,
  } = props;
  return ({
    container : {
      display : "flex",
    },
    reactDatePickerBase: {
      width : "100%",
      '& .react-datepicker-popper' : {
        zIndex: "10 !important",
      },
      '& .react-datepicker__header' : {
        background: get(color, 'white'),
        borderBottom: 0,
      },
      '& .month-year-container' : {
        marginLeft: get(margin, "m10"),
        marginRight: get(margin, "m10"),
        zIndex: 100,
        alignItems: "center",
        justifyContent: "center",
      },
      '& .react-datepicker__day' : {
        fontSize: get(fontSize, 'siteTitle'),
        margin : get(margin, 'm4'),
        color : get(color, 'link'),
        padding : get(padding, 'p4'),
      },
      '& .react-datepicker__day-name' : {
        margin : get(margin, 'm4'),
        padding : get(padding, 'p4'),
      },
      '& .react-datepicker__day-names' : {
        paddingLeft : get(padding, 'p5'),
        paddingRight: get(padding, 'p5'),
      },
      '& .react-datepicker__day--today' : {
        borderRadius: get(borderRadius, "br3"),
        backgroundColor: get(color, 'white'),
        color : get(color, 'link'),
        border : `1px solid ${get(color, 'primaryButtonBackground')}`,
        fontWeight: get(fontWeight, 'normal'),
      },
      '& .react-datepicker__day:hover' : {
        backgroundColor : get(color, "lightHover"),
      },
      '& .react-datepicker__day--selected' : {
        color: get(color, 'white'),
        backgroundColor : get(color, 'primaryButtonBackground'),
      },
      '& .react-datepicker__day--selected:hover' : {
        color: get(color, 'primaryButtonBackground'),
        backgroundColor : get(color, 'lightHover'),
      },
      '& .react-datepicker__day--disabled' : {
        color: `${get(color, 'disabledText')}`,
      },
      '& .react-datepicker__day--disabled:hover' : {
        backgroundColor : 'transparent',
      },
    },
    labelBetweenRanges : {
      display: "flex",
      background : get(color, 'gray'),
      paddingLeft : get(padding, 'p10'),
      paddingRight : get(padding, 'p10'),
      justifyContent: "center !important",
      alignItems: "center !important",
    },
    headerTitle : {
      marginLeft : get(margin, 'm20'),
      marginRight : get(margin, 'm20'),
      color : get(color, 'primaryButtonBackground'),
      fontWeight : get(typography, 'fontWeightBold'),
      fontFamily : get(typography, 'pageTitle'),
      fontSize : get(fontSize, "siteTitle"),
    },
    navigationButton : {
      minWidth : 40,
      minHeight : 40,
      background: get(color, 'white'),
      borderRadius: get(borderRadius, 'br3'),
      border : `1px solid ${get(color,"primaryButtonBackground")}`,
      margin : get(margin, 'm4'),
    },
    headerContainer : {
      margin: get(margin, 'm10'),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    clearButton : {
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0,
      minWidth : 40,
      maxWidth : 40,
    },
    borderRightNoRadius: {
      '& .MuiInputBase-root' : {
        width : "100% !important",
        borderTopRightRadius: 0,
        borderBottomRightRadius : 0,
      },
      padding : `${get(padding, 'p0')} !important`,
    },
    borderLeftNoRadius : {
      '& .MuiInputBase-root' : {
        width : "100% !important",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius : 0,
      },
      padding : `0px !important`,
    },
    customInputClass : {
      margin : `${get(margin, 'm0')} !important`,
      padding : `${get(padding, 'p0')} !important`,
    },
  });
}

export default styles;
